import * as React from 'react'
import Stack from '../Stack'
import * as Styled from './SplitModule.styles'

const SplitModule = ({
  alignMainContent,
  alignImageToBottom,
  mobileAlignImageToBottom,
  image,
  mainContent,
  children,
  backgroundColor,
  splitBackgroundColor,
  backgroundImage,
  mobileBackgroundImage,
  textColor,
  mobileTextColor,
  topPadding,
  bottomPadding,
  width,
  ...props
}) => (
  <Styled.Section
    className="leshen-split-module"
    splitBackgroundColor={splitBackgroundColor}
    alignMainContent={alignMainContent}
    alignImageToBottom={alignImageToBottom}
    hasBackgroundColorOrImage={backgroundColor || Boolean(backgroundImage)}
    mobileAlignImageToBottom={mobileAlignImageToBottom}
    topPadding={topPadding}
    bottomPadding={bottomPadding}
    width={width}
    {...props}
  >
    <Styled.MainContentArea
      className="main-content-area"
      splitBackgroundColor={splitBackgroundColor}
      topPadding={topPadding}
      bottomPadding={bottomPadding}
      width={width}
    >
      <Stack className="stack" alignMainContent={alignMainContent}>
        {!alignImageToBottom && <Styled.DesktopImg>{image}</Styled.DesktopImg>}
        {!mobileAlignImageToBottom && (
          <Styled.MobileImg>{image}</Styled.MobileImg>
        )}
        {mainContent}
        {alignImageToBottom && <Styled.DesktopImg>{image}</Styled.DesktopImg>}
        {mobileAlignImageToBottom && (
          <Styled.MobileImg>{image}</Styled.MobileImg>
        )}
      </Stack>
    </Styled.MainContentArea>
    <Styled.ModuleArea
      className={`module-area background-color-${backgroundColor || 'default'}`}
      backgroundColor={backgroundColor}
      hasBackgroundImage={Boolean(backgroundImage)}
      topPadding={topPadding}
      bottomPadding={bottomPadding}
      width={width}
    >
      {backgroundImage && (
        <Styled.BackgroundImage mobileBackgroundImage={mobileBackgroundImage}>
          {backgroundImage}
        </Styled.BackgroundImage>
      )}
      {mobileBackgroundImage && (
        <Styled.MobileBackgroundImage>
          {mobileBackgroundImage}
        </Styled.MobileBackgroundImage>
      )}
      {children}
    </Styled.ModuleArea>
  </Styled.Section>
)

export default SplitModule
